import { uniqueId } from 'lodash';
import { IDatiqModalFullScreen } from './datiq-modal-full-screen.interface';
import {
    DATIQ_DEFAULT_EMPTY_LABEL,
    DATIQ_DEFAULT_ID,
} from '@dat/datiq-core/models';

export const emptyDatiqModalFullScreen: IDatiqModalFullScreen = {
    id: DATIQ_DEFAULT_ID('link-'),
    closeOnBgClick: true,
    closeOnEsc: true,
    showClose: true,
    title: DATIQ_DEFAULT_EMPTY_LABEL,
};
